"use strict";
(self.webpackChunkdemel_shopify_template = self.webpackChunkdemel_shopify_template || []).push([
  [718], {
    1667: (e, t, n) => {
      n.r(t), n.d(t, {
        default: () => ln
      });
      var r = new WeakMap,
        o = new WeakMap,
        a = {},
        c = 0,
        i = function (e, t, n) {
          void 0 === t && (t = function (e) {
            return "undefined" == typeof document ? null : (Array.isArray(e) ? e[0] : e).ownerDocument.body
          }(e)), void 0 === n && (n = "data-aria-hidden");
          var i = Array.isArray(e) ? e : [e];
          a[n] || (a[n] = new WeakMap);
          var l = a[n],
            s = [],
            u = new Set,
            d = function (e) {
              e && !u.has(e) && (u.add(e), d(e.parentNode))
            };
          i.forEach(d);
          var f = function (e) {
            !e || i.indexOf(e) >= 0 || Array.prototype.forEach.call(e.children, (function (e) {
              if (u.has(e)) f(e);
              else {
                var t = e.getAttribute("aria-hidden"),
                  a = null !== t && "false" !== t,
                  c = (r.get(e) || 0) + 1,
                  i = (l.get(e) || 0) + 1;
                r.set(e, c), l.set(e, i), s.push(e), 1 === c && a && o.set(e, !0), 1 === i && e.setAttribute(n, "true"), a || e.setAttribute("aria-hidden", "true")
              }
            }))
          };
          return f(t), u.clear(), c++,
            function () {
              s.forEach((function (e) {
                var t = r.get(e) - 1,
                  a = l.get(e) - 1;
                r.set(e, t), l.set(e, a), t || (o.has(e) || e.removeAttribute("aria-hidden"), o.delete(e)), a || e.removeAttribute(n)
              })), --c || (r = new WeakMap, r = new WeakMap, o = new WeakMap, a = {})
            }
        };
      var l = function () {
        return l = Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++)
            for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          return e
        }, l.apply(this, arguments)
      };

      function s(e, t) {
        var n = {};
        for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
        if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
          var o = 0;
          for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]])
        }
        return n
      }
      Object.create;
      Object.create;
      var u = n(7401),
        d = n.t(u, 2),
        f = "right-scroll-bar-position",
        p = "width-before-scroll-bar";

      function m(e, t) {
        return function (e, t) {
          var n = (0, u.useState)((function () {
            return {
              value: e,
              callback: t,
              facade: {
                get current() {
                  return n.value
                },
                set current(e) {
                  var t = n.value;
                  t !== e && (n.value = e, n.callback(e, t))
                }
              }
            }
          }))[0];
          return n.callback = t, n.facade
        }(t || null, (function (t) {
          return e.forEach((function (e) {
            return function (e, t) {
              return "function" == typeof e ? e(t) : e && (e.current = t), e
            }(e, t)
          }))
        }))
      }

      function h(e) {
        return e
      }

      function v(e, t) {
        void 0 === t && (t = h);
        var n = [],
          r = !1,
          o = {
            read: function () {
              if (r) throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
              return n.length ? n[n.length - 1] : e
            },
            useMedium: function (e) {
              var o = t(e, r);
              return n.push(o),
                function () {
                  n = n.filter((function (e) {
                    return e !== o
                  }))
                }
            },
            assignSyncMedium: function (e) {
              for (r = !0; n.length;) {
                var t = n;
                n = [], t.forEach(e)
              }
              n = {
                push: function (t) {
                  return e(t)
                },
                filter: function () {
                  return n
                }
              }
            },
            assignMedium: function (e) {
              r = !0;
              var t = [];
              if (n.length) {
                var o = n;
                n = [], o.forEach(e), t = n
              }
              var a = function () {
                var n = t;
                t = [], n.forEach(e)
              },
                c = function () {
                  return Promise.resolve().then(a)
                };
              c(), n = {
                push: function (e) {
                  t.push(e), c()
                },
                filter: function (e) {
                  return t = t.filter(e), n
                }
              }
            }
          };
        return o
      }
      var g = function (e) {
        void 0 === e && (e = {});
        var t = v(null);
        return t.options = l({
          async: !0,
          ssr: !1
        }, e), t
      }(),
        E = function () { },
        w = u.forwardRef((function (e, t) {
          var n = u.useRef(null),
            r = u.useState({
              onScrollCapture: E,
              onWheelCapture: E,
              onTouchMoveCapture: E
            }),
            o = r[0],
            a = r[1],
            c = e.forwardProps,
            i = e.children,
            d = e.className,
            f = e.removeScrollBar,
            p = e.enabled,
            h = e.shards,
            v = e.sideCar,
            w = e.noIsolation,
            b = e.inert,
            y = e.allowPinchZoom,
            S = e.as,
            C = void 0 === S ? "div" : S,
            P = s(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as"]),
            R = v,
            x = m([n, t]),
            T = l(l({}, P), o);
          return u.createElement(u.Fragment, null, p && u.createElement(R, {
            sideCar: g,
            removeScrollBar: f,
            shards: h,
            noIsolation: w,
            inert: b,
            setCallbacks: a,
            allowPinchZoom: !!y,
            lockRef: n
          }), c ? u.cloneElement(u.Children.only(i), l(l({}, T), {
            ref: x
          })) : u.createElement(C, l({}, T, {
            className: d,
            ref: x
          }), i))
        }));
      w.defaultProps = {
        enabled: !0,
        removeScrollBar: !0,
        inert: !1
      }, w.classNames = {
        fullWidth: p,
        zeroRight: f
      };
      var b, y = function (e) {
        var t = e.sideCar,
          n = s(e, ["sideCar"]);
        if (!t) throw new Error("Sidecar: please provide `sideCar` property to import the right car");
        var r = t.read();
        if (!r) throw new Error("Sidecar medium not found");
        return u.createElement(r, l({}, n))
      };
      y.isSideCarExport = !0;

      function S() {
        if (!document) return null;
        var e = document.createElement("style");
        e.type = "text/css";
        var t = b || n.nc;
        return t && e.setAttribute("nonce", t), e
      }
      var C = function () {
        var e = 0,
          t = null;
        return {
          add: function (n) {
            0 == e && (t = S()) && (function (e, t) {
              e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t))
            }(t, n), function (e) {
              (document.head || document.getElementsByTagName("head")[0]).appendChild(e)
            }(t)), e++
          },
          remove: function () {
            !--e && t && (t.parentNode && t.parentNode.removeChild(t), t = null)
          }
        }
      },
        P = function () {
          var e = function () {
            var e = C();
            return function (t, n) {
              u.useEffect((function () {
                return e.add(t),
                  function () {
                    e.remove()
                  }
              }), [t && n])
            }
          }();
          return function (t) {
            var n = t.styles,
              r = t.dynamic;
            return e(n, r), null
          }
        },
        R = {
          left: 0,
          top: 0,
          right: 0,
          gap: 0
        },
        x = function (e) {
          return parseInt(e || "", 10) || 0
        },
        T = function (e) {
          if (void 0 === e && (e = "margin"), "undefined" == typeof window) return R;
          var t = function (e) {
            var t = window.getComputedStyle(document.body),
              n = t["padding" === e ? "paddingLeft" : "marginLeft"],
              r = t["padding" === e ? "paddingTop" : "marginTop"],
              o = t["padding" === e ? "paddingRight" : "marginRight"];
            return [x(n), x(r), x(o)]
          }(e),
            n = document.documentElement.clientWidth,
            r = window.innerWidth;
          return {
            left: t[0],
            top: t[1],
            right: t[2],
            gap: Math.max(0, r - n + t[2] - t[0])
          }
        },
        O = P(),
        _ = function (e, t, n, r) {
          var o = e.left,
            a = e.top,
            c = e.right,
            i = e.gap;
          return void 0 === n && (n = "margin"), "\n  .".concat("with-scroll-bars-hidden", " {\n   overflow: hidden ").concat(r, ";\n   padding-right: ").concat(i, "px ").concat(r, ";\n  }\n  body {\n    overflow: hidden ").concat(r, ";\n    overscroll-behavior: contain;\n    ").concat([t && "position: relative ".concat(r, ";"), "margin" === n && "\n    padding-left: ".concat(o, "px;\n    padding-top: ").concat(a, "px;\n    padding-right: ").concat(c, "px;\n    margin-left:0;\n    margin-top:0;\n    margin-right: ").concat(i, "px ").concat(r, ";\n    "), "padding" === n && "padding-right: ".concat(i, "px ").concat(r, ";")].filter(Boolean).join(""), "\n  }\n  \n  .").concat(f, " {\n    right: ").concat(i, "px ").concat(r, ";\n  }\n  \n  .").concat(p, " {\n    margin-right: ").concat(i, "px ").concat(r, ";\n  }\n  \n  .").concat(f, " .").concat(f, " {\n    right: 0 ").concat(r, ";\n  }\n  \n  .").concat(p, " .").concat(p, " {\n    margin-right: 0 ").concat(r, ";\n  }\n  \n  body {\n    ").concat("--removed-body-scroll-bar-size", ": ").concat(i, "px;\n  }\n")
        },
        A = function (e) {
          var t = e.noRelative,
            n = e.noImportant,
            r = e.gapMode,
            o = void 0 === r ? "margin" : r,
            a = u.useMemo((function () {
              return T(o)
            }), [o]);
          return u.createElement(O, {
            styles: _(a, !t, o, n ? "" : "!important")
          })
        },
        L = !1;
      if ("undefined" != typeof window) try {
        var N = Object.defineProperty({}, "passive", {
          get: function () {
            return L = !0, !0
          }
        });
        window.addEventListener("test", N, N), window.removeEventListener("test", N, N)
      } catch (e) {
        L = !1
      }
      var k = !!L && {
        passive: !1
      },
        D = function (e, t) {
          var n = t;
          do {
            if ("undefined" != typeof ShadowRoot && n instanceof ShadowRoot && (n = n.host), F(e, n)) {
              var r = M(e, n);
              if (r[1] > r[2]) return !0
            }
            n = n.parentNode
          } while (n && n !== document.body);
          return !1
        },
        F = function (e, t) {
          return "v" === e ? function (e) {
            var t = window.getComputedStyle(e);
            return "hidden" !== t.overflowY && !(t.overflowY === t.overflowX && "visible" === t.overflowY)
          }(t) : function (e) {
            var t = window.getComputedStyle(e);
            return "hidden" !== t.overflowX && !(t.overflowY === t.overflowX && "visible" === t.overflowX)
          }(t)
        },
        M = function (e, t) {
          return "v" === e ? function (e) {
            return [e.scrollTop, e.scrollHeight, e.clientHeight]
          }(t) : function (e) {
            return [e.scrollLeft, e.scrollWidth, e.clientWidth]
          }(t)
        },
        z = function (e) {
          return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0]
        },
        I = function (e) {
          return [e.deltaX, e.deltaY]
        },
        W = function (e) {
          return e && "current" in e ? e.current : e
        },
        $ = function (e) {
          return "\n  .block-interactivity-".concat(e, " {pointer-events: none;}\n  .allow-interactivity-").concat(e, " {pointer-events: all;}\n")
        },
        U = 0,
        B = [];
      const j = function (e, t) {
        return e.useMedium(t), y
      }(g, (function (e) {
        var t = u.useRef([]),
          n = u.useRef([0, 0]),
          r = u.useRef(),
          o = u.useState(U++)[0],
          a = u.useState((function () {
            return P()
          }))[0],
          c = u.useRef(e);
        u.useEffect((function () {
          c.current = e
        }), [e]), u.useEffect((function () {
          if (e.inert) {
            document.body.classList.add("block-interactivity-".concat(o));
            var t = function (e, t, n) {
              if (n || 2 === arguments.length)
                for (var r, o = 0, a = t.length; o < a; o++) !r && o in t || (r || (r = Array.prototype.slice.call(t, 0, o)), r[o] = t[o]);
              return e.concat(r || Array.prototype.slice.call(t))
            }([e.lockRef.current], (e.shards || []).map(W), !0).filter(Boolean);
            return t.forEach((function (e) {
              return e.classList.add("allow-interactivity-".concat(o))
            })),
              function () {
                document.body.classList.remove("block-interactivity-".concat(o)), t.forEach((function (e) {
                  return e.classList.remove("allow-interactivity-".concat(o))
                }))
              }
          }
        }), [e.inert, e.lockRef.current, e.shards]);
        var i = u.useCallback((function (e, t) {
          if ("touches" in e && 2 === e.touches.length) return !c.current.allowPinchZoom;
          var o, a = z(e),
            i = n.current,
            l = "deltaX" in e ? e.deltaX : i[0] - a[0],
            s = "deltaY" in e ? e.deltaY : i[1] - a[1],
            u = e.target,
            d = Math.abs(l) > Math.abs(s) ? "h" : "v";
          if ("touches" in e && "h" === d && "range" === u.type) return !1;
          var f = D(d, u);
          if (!f) return !0;
          if (f ? o = d : (o = "v" === d ? "h" : "v", f = D(d, u)), !f) return !1;
          if (!r.current && "changedTouches" in e && (l || s) && (r.current = o), !o) return !0;
          var p = r.current || o;
          return function (e, t, n, r, o) {
            var a = function (e, t) {
              return "h" === e && "rtl" === t ? -1 : 1
            }(e, window.getComputedStyle(t).direction),
              c = a * r,
              i = n.target,
              l = t.contains(i),
              s = !1,
              u = c > 0,
              d = 0,
              f = 0;
            do {
              var p = M(e, i),
                m = p[0],
                h = p[1] - p[2] - a * m;
              (m || h) && F(e, i) && (d += h, f += m), i = i.parentNode
            } while (!l && i !== document.body || l && (t.contains(i) || t === i));
            return (u && (o && 0 === d || !o && c > d) || !u && (o && 0 === f || !o && -c > f)) && (s = !0), s
          }(p, t, e, "h" === p ? l : s, !0)
        }), []),
          l = u.useCallback((function (e) {
            var n = e;
            if (B.length && B[B.length - 1] === a) {
              var r = "deltaY" in n ? I(n) : z(n),
                o = t.current.filter((function (e) {
                  return e.name === n.type && e.target === n.target && function (e, t) {
                    return e[0] === t[0] && e[1] === t[1]
                  }(e.delta, r)
                }))[0];
              if (o && o.should) n.preventDefault();
              else if (!o) {
                var l = (c.current.shards || []).map(W).filter(Boolean).filter((function (e) {
                  return e.contains(n.target)
                }));
                (l.length > 0 ? i(n, l[0]) : !c.current.noIsolation) && n.preventDefault()
              }
            }
          }), []),
          s = u.useCallback((function (e, n, r, o) {
            var a = {
              name: e,
              delta: n,
              target: r,
              should: o
            };
            t.current.push(a), setTimeout((function () {
              t.current = t.current.filter((function (e) {
                return e !== a
              }))
            }), 1)
          }), []),
          d = u.useCallback((function (e) {
            n.current = z(e), r.current = void 0
          }), []),
          f = u.useCallback((function (t) {
            s(t.type, I(t), t.target, i(t, e.lockRef.current))
          }), []),
          p = u.useCallback((function (t) {
            s(t.type, z(t), t.target, i(t, e.lockRef.current))
          }), []);
        u.useEffect((function () {
          return B.push(a), e.setCallbacks({
            onScrollCapture: f,
            onWheelCapture: f,
            onTouchMoveCapture: p
          }), document.addEventListener("wheel", l, k), document.addEventListener("touchmove", l, k), document.addEventListener("touchstart", d, k),
            function () {
              B = B.filter((function (e) {
                return e !== a
              })), document.removeEventListener("wheel", l, k), document.removeEventListener("touchmove", l, k), document.removeEventListener("touchstart", d, k)
            }
        }), []);
        var m = e.removeScrollBar,
          h = e.inert;
        return u.createElement(u.Fragment, null, h ? u.createElement(a, {
          styles: $(o)
        }) : null, m ? u.createElement(A, {
          gapMode: "margin"
        }) : null)
      }));
      var H = u.forwardRef((function (e, t) {
        return u.createElement(w, l({}, e, {
          ref: t,
          sideCar: j
        }))
      }));
      H.classNames = w.classNames;
      const Y = H,
        X = Boolean(null === globalThis || void 0 === globalThis ? void 0 : globalThis.document) ? u.useLayoutEffect : () => { },
        q = d["useId".toString()] || (() => { });
      let K = 0;

      function V(e) {
        const [t, n] = u.useState(q());
        return X((() => {
          e || n((e => null != e ? e : String(K++)))
        }), [e]), e || (t ? `radix-${t}` : "")
      }

      function Z(...e) {
        return t => e.forEach((e => function (e, t) {
          "function" == typeof e ? e(t) : null != e && (e.current = t)
        }(e, t)))
      }

      function J(...e) {
        return u.useCallback(Z(...e), e)
      }

      function Q() {
        return Q = Object.assign ? Object.assign.bind() : function (e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = arguments[t];
            for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r])
          }
          return e
        }, Q.apply(this, arguments)
      }
      const G = u.forwardRef(((e, t) => {
        const {
          children: n,
          ...r
        } = e;
        return u.Children.toArray(n).some(ne) ? u.createElement(u.Fragment, null, u.Children.map(n, (e => ne(e) ? u.createElement(ee, Q({}, r, {
          ref: t
        }), e.props.children) : e))) : u.createElement(ee, Q({}, r, {
          ref: t
        }), n)
      }));
      G.displayName = "Slot";
      const ee = u.forwardRef(((e, t) => {
        const {
          children: n,
          ...r
        } = e;
        return u.isValidElement(n) ? u.cloneElement(n, {
          ...re(r, n.props),
          ref: Z(t, n.ref)
        }) : u.Children.count(n) > 1 ? u.Children.only(null) : null
      }));
      ee.displayName = "SlotClone";
      const te = ({
        children: e
      }) => u.createElement(u.Fragment, null, e);

      function ne(e) {
        return u.isValidElement(e) && e.type === te
      }

      function re(e, t) {
        const n = {
          ...t
        };
        for (const r in t) {
          const o = e[r],
            a = t[r];
          /^on[A-Z]/.test(r) ? n[r] = (...e) => {
            null == a || a(...e), null == o || o(...e)
          } : "style" === r ? n[r] = {
            ...o,
            ...a
          } : "className" === r && (n[r] = [o, a].filter(Boolean).join(" "))
        }
        return {
          ...e,
          ...n
        }
      }
      const oe = ["a", "button", "div", "h2", "h3", "img", "li", "nav", "ol", "p", "span", "svg", "ul"].reduce(((e, t) => ({
        ...e,
        [t]: u.forwardRef(((e, n) => {
          const {
            asChild: r,
            ...o
          } = e, a = r ? G : t;
          return u.useEffect((() => {
            window[Symbol.for("radix-ui")] = !0
          }), []), u.createElement(a, Q({}, o, {
            ref: n
          }))
        }))
      })), {}),
        ae = e => {
          const {
            present: t,
            children: n
          } = e, r = function (e) {
            const [t, n] = u.useState(), r = u.useRef({}), o = u.useRef(e), a = u.useRef("none"), c = e ? "mounted" : "unmounted", [i, l] = function (e, t) {
              return u.useReducer(((e, n) => {
                const r = t[e][n];
                return null != r ? r : e
              }), e)
            }(c, {
              mounted: {
                UNMOUNT: "unmounted",
                ANIMATION_OUT: "unmountSuspended"
              },
              unmountSuspended: {
                MOUNT: "mounted",
                ANIMATION_END: "unmounted"
              },
              unmounted: {
                MOUNT: "mounted"
              }
            });
            return u.useEffect((() => {
              const e = ce(r.current);
              a.current = "mounted" === i ? e : "none"
            }), [i]), X((() => {
              const t = r.current,
                n = o.current;
              if (n !== e) {
                const r = a.current,
                  c = ce(t);
                if (e) l("MOUNT");
                else if ("none" === c || "none" === (null == t ? void 0 : t.display)) l("UNMOUNT");
                else {
                  const e = r !== c;
                  l(n && e ? "ANIMATION_OUT" : "UNMOUNT")
                }
                o.current = e
              }
            }), [e, l]), X((() => {
              if (t) {
                const e = e => {
                  const n = ce(r.current).includes(e.animationName);
                  e.target === t && n && l("ANIMATION_END")
                },
                  n = e => {
                    e.target === t && (a.current = ce(r.current))
                  };
                return t.addEventListener("animationstart", n), t.addEventListener("animationcancel", e), t.addEventListener("animationend", e), () => {
                  t.removeEventListener("animationstart", n), t.removeEventListener("animationcancel", e), t.removeEventListener("animationend", e)
                }
              }
              l("ANIMATION_END")
            }), [t, l]), {
              isPresent: ["mounted", "unmountSuspended"].includes(i),
              ref: u.useCallback((e => {
                e && (r.current = getComputedStyle(e)), n(e)
              }), [])
            }
          }(t), o = "function" == typeof n ? n({
            present: r.isPresent
          }) : u.Children.only(n), a = J(r.ref, o.ref);
          return "function" == typeof n || r.isPresent ? u.cloneElement(o, {
            ref: a
          }) : null
        };

      function ce(e) {
        return (null == e ? void 0 : e.animationName) || "none"
      }
      ae.displayName = "Presence";
      let ie = 0;

      function le() {
        u.useEffect((() => {
          var e, t;
          const n = document.querySelectorAll("[data-radix-focus-guard]");
          return document.body.insertAdjacentElement("afterbegin", null !== (e = n[0]) && void 0 !== e ? e : se()), document.body.insertAdjacentElement("beforeend", null !== (t = n[1]) && void 0 !== t ? t : se()), ie++, () => {
            1 === ie && document.querySelectorAll("[data-radix-focus-guard]").forEach((e => e.remove())), ie--
          }
        }), [])
      }

      function se() {
        const e = document.createElement("span");
        return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none", e
      }
      var ue = n(2674);
      const de = u.forwardRef(((e, t) => {
        var n, r;
        const {
          containerRef: o,
          style: a,
          ...c
        } = e, i = null !== (n = null == o ? void 0 : o.current) && void 0 !== n ? n : null === globalThis || void 0 === globalThis || null === (r = globalThis.document) || void 0 === r ? void 0 : r.body, [, l] = u.useState({});
        return X((() => {
          l({})
        }), []), i ? ue.createPortal(u.createElement(oe.div, Q({
          "data-radix-portal": ""
        }, c, {
          ref: t,
          style: i === document.body ? {
            position: "absolute",
            top: 0,
            left: 0,
            zIndex: 2147483647,
            ...a
          } : void 0
        })), i) : null
      }));

      function fe(e) {
        const t = u.useRef(e);
        return u.useEffect((() => {
          t.current = e
        })), u.useMemo((() => (...e) => {
          var n;
          return null === (n = t.current) || void 0 === n ? void 0 : n.call(t, ...e)
        }), [])
      }
      const pe = {
        bubbles: !1,
        cancelable: !0
      },
        me = u.forwardRef(((e, t) => {
          const {
            loop: n = !1,
            trapped: r = !1,
            onMountAutoFocus: o,
            onUnmountAutoFocus: a,
            ...c
          } = e, [i, l] = u.useState(null), s = fe(o), d = fe(a), f = u.useRef(null), p = J(t, (e => l(e))), m = u.useRef({
            paused: !1,
            pause() {
              this.paused = !0
            },
            resume() {
              this.paused = !1
            }
          }).current;
          u.useEffect((() => {
            if (r) {
              function e(e) {
                if (m.paused || !i) return;
                const t = e.target;
                i.contains(t) ? f.current = t : Ee(f.current, {
                  select: !0
                })
              }

              function t(e) {
                !m.paused && i && (i.contains(e.relatedTarget) || Ee(f.current, {
                  select: !0
                }))
              }
              return document.addEventListener("focusin", e), document.addEventListener("focusout", t), () => {
                document.removeEventListener("focusin", e), document.removeEventListener("focusout", t)
              }
            }
          }), [r, i, m.paused]), u.useEffect((() => {
            if (i) {
              we.add(m);
              const e = document.activeElement;
              if (!i.contains(e)) {
                const t = new Event("focusScope.autoFocusOnMount", pe);
                i.addEventListener("focusScope.autoFocusOnMount", s), i.dispatchEvent(t), t.defaultPrevented || (function (e, {
                  select: t = !1
                } = {}) {
                  const n = document.activeElement;
                  for (const r of e)
                    if (Ee(r, {
                      select: t
                    }), document.activeElement !== n) return
                }(he(i).filter((e => "A" !== e.tagName)), {
                  select: !0
                }), document.activeElement === e && Ee(i))
              }
              return () => {
                i.removeEventListener("focusScope.autoFocusOnMount", s), setTimeout((() => {
                  const t = new Event("focusScope.autoFocusOnUnmount", pe);
                  i.addEventListener("focusScope.autoFocusOnUnmount", d), i.dispatchEvent(t), t.defaultPrevented || Ee(null != e ? e : document.body, {
                    select: !0
                  }), i.removeEventListener("focusScope.autoFocusOnUnmount", d), we.remove(m)
                }), 0)
              }
            }
          }), [i, s, d, m]);
          const h = u.useCallback((e => {
            if (!n && !r) return;
            if (m.paused) return;
            const t = "Tab" === e.key && !e.altKey && !e.ctrlKey && !e.metaKey,
              o = document.activeElement;
            if (t && o) {
              const t = e.currentTarget,
                [r, a] = function (e) {
                  const t = he(e);
                  return [ve(t, e), ve(t.reverse(), e)]
                }(t);
              r && a ? e.shiftKey || o !== a ? e.shiftKey && o === r && (e.preventDefault(), n && Ee(a, {
                select: !0
              })) : (e.preventDefault(), n && Ee(r, {
                select: !0
              })) : o === t && e.preventDefault()
            }
          }), [n, r, m.paused]);
          return u.createElement(oe.div, Q({
            tabIndex: -1
          }, c, {
            ref: p,
            onKeyDown: h
          }))
        }));

      function he(e) {
        const t = [],
          n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
            acceptNode: e => {
              const t = "INPUT" === e.tagName && "hidden" === e.type;
              return e.disabled || e.hidden || t ? NodeFilter.FILTER_SKIP : e.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP
            }
          });
        for (; n.nextNode();) t.push(n.currentNode);
        return t
      }

      function ve(e, t) {
        for (const n of e)
          if (!ge(n, {
            upTo: t
          })) return n
      }

      function ge(e, {
        upTo: t
      }) {
        if ("hidden" === getComputedStyle(e).visibility) return !0;
        for (; e;) {
          if (void 0 !== t && e === t) return !1;
          if ("none" === getComputedStyle(e).display) return !0;
          e = e.parentElement
        }
        return !1
      }

      function Ee(e, {
        select: t = !1
      } = {}) {
        if (e && e.focus) {
          const n = document.activeElement;
          e.focus({
            preventScroll: !0
          }), e !== n && function (e) {
            return e instanceof HTMLInputElement && "select" in e
          }(e) && t && e.select()
        }
      }
      const we = function () {
        let e = [];
        return {
          add(t) {
            const n = e[0];
            t !== n && (null == n || n.pause()), e = be(e, t), e.unshift(t)
          },
          remove(t) {
            var n;
            e = be(e, t), null === (n = e[0]) || void 0 === n || n.resume()
          }
        }
      }();

      function be(e, t) {
        const n = [...e],
          r = n.indexOf(t);
        return -1 !== r && n.splice(r, 1), n
      }
      let ye, Se = 0;

      function Ce(e, t, {
        checkForDefaultPrevented: n = !0
      } = {}) {
        return function (r) {
          if (null == e || e(r), !1 === n || !r.defaultPrevented) return null == t ? void 0 : t(r)
        }
      }
      const Pe = u.createContext({
        layers: new Set,
        layersWithOutsidePointerEventsDisabled: new Set,
        branches: new Set
      }),
        Re = u.forwardRef(((e, t) => {
          const {
            disableOutsidePointerEvents: n = !1,
            onEscapeKeyDown: r,
            onPointerDownOutside: o,
            onFocusOutside: a,
            onInteractOutside: c,
            onDismiss: i,
            ...l
          } = e, s = u.useContext(Pe), [d, f] = u.useState(null), [, p] = u.useState({}), m = J(t, (e => f(e))), h = Array.from(s.layers), [v] = [...s.layersWithOutsidePointerEventsDisabled].slice(-1), g = h.indexOf(v), E = d ? h.indexOf(d) : -1, w = s.layersWithOutsidePointerEventsDisabled.size > 0, b = E >= g, y = function (e) {
            const t = fe((e => {
              const t = e.target,
                n = [...s.branches].some((e => e.contains(t)));
              b && !n && (null == o || o(e), null == c || c(e), e.defaultPrevented || null == i || i())
            })),
              n = u.useRef(!1);
            return u.useEffect((() => {
              const e = e => {
                e.target && !n.current && Te("dismissableLayer.pointerDownOutside", t, {
                  originalEvent: e
                }), n.current = !1
              },
                r = window.setTimeout((() => {
                  document.addEventListener("pointerdown", e)
                }), 0);
              return () => {
                window.clearTimeout(r), document.removeEventListener("pointerdown", e)
              }
            }), [t]), {
              onPointerDownCapture: () => n.current = !0
            }
          }(), S = function (e) {
            const t = fe((e => {
              const t = e.target;
              [...s.branches].some((e => e.contains(t))) || (null == a || a(e), null == c || c(e), e.defaultPrevented || null == i || i())
            })),
              n = u.useRef(!1);
            return u.useEffect((() => {
              const e = e => {
                e.target && !n.current && Te("dismissableLayer.focusOutside", t, {
                  originalEvent: e
                })
              };
              return document.addEventListener("focusin", e), () => document.removeEventListener("focusin", e)
            }), [t]), {
              onFocusCapture: () => n.current = !0,
              onBlurCapture: () => n.current = !1
            }
          }();
          return function (e) {
            const t = fe(e);
            u.useEffect((() => {
              const e = e => {
                "Escape" === e.key && t(e)
              };
              return document.addEventListener("keydown", e), () => document.removeEventListener("keydown", e)
            }), [t])
          }((e => {
            E === s.layers.size - 1 && (null == r || r(e), e.defaultPrevented || null == i || i())
          })),
            function ({
              disabled: e
            }) {
              const t = u.useRef(!1);
              X((() => {
                if (e) {
                  function n() {
                    Se--, 0 === Se && (document.body.style.pointerEvents = ye)
                  }

                  function r(e) {
                    t.current = "mouse" !== e.pointerType
                  }
                  return 0 === Se && (ye = document.body.style.pointerEvents), document.body.style.pointerEvents = "none", Se++, document.addEventListener("pointerup", r), () => {
                    t.current ? document.addEventListener("click", n, {
                      once: !0
                    }) : n(), document.removeEventListener("pointerup", r)
                  }
                }
              }), [e])
            }({
              disabled: n
            }), u.useEffect((() => {
              d && (n && s.layersWithOutsidePointerEventsDisabled.add(d), s.layers.add(d), xe())
            }), [d, n, s]), u.useEffect((() => () => {
              d && (s.layers.delete(d), s.layersWithOutsidePointerEventsDisabled.delete(d), xe())
            }), [d, s]), u.useEffect((() => {
              const e = () => p({});
              return document.addEventListener("dismissableLayer.update", e), () => document.removeEventListener("dismissableLayer.update", e)
            }), []), u.createElement(oe.div, Q({}, l, {
              ref: m,
              style: {
                pointerEvents: w ? b ? "auto" : "none" : void 0,
                ...e.style
              },
              onFocusCapture: Ce(e.onFocusCapture, S.onFocusCapture),
              onBlurCapture: Ce(e.onBlurCapture, S.onBlurCapture),
              onPointerDownCapture: Ce(e.onPointerDownCapture, y.onPointerDownCapture)
            }))
        }));

      function xe() {
        const e = new Event("dismissableLayer.update");
        document.dispatchEvent(e)
      }

      function Te(e, t, n) {
        const r = n.originalEvent.target,
          o = new CustomEvent(e, {
            bubbles: !1,
            cancelable: !0,
            detail: n
          });
        return t && r.addEventListener(e, t, {
          once: !0
        }), !r.dispatchEvent(o)
      }
      const Oe = u.forwardRef(((e, t) => {
        const {
          children: n,
          width: r = 10,
          height: o = 5,
          ...a
        } = e;
        return u.createElement(oe.svg, Q({}, a, {
          ref: t,
          width: r,
          height: o,
          viewBox: "0 0 30 10",
          preserveAspectRatio: "none"
        }), e.asChild ? n : u.createElement("polygon", {
          points: "0,0 30,0 15,10"
        }))
      })),
        _e = Oe;

      function Ae(e) {
        const [t, n] = u.useState(void 0);
        return u.useEffect((() => {
          if (e) {
            const t = new ResizeObserver((t => {
              if (!Array.isArray(t)) return;
              if (!t.length) return;
              const r = t[0];
              let o, a;
              if ("borderBoxSize" in r) {
                const e = r.borderBoxSize,
                  t = Array.isArray(e) ? e[0] : e;
                o = t.inlineSize, a = t.blockSize
              } else {
                const t = e.getBoundingClientRect();
                o = t.width, a = t.height
              }
              n({
                width: o,
                height: a
              })
            }));
            return t.observe(e, {
              box: "border-box"
            }), () => t.unobserve(e)
          }
          n(void 0)
        }), [e]), t
      }
      let Le;
      const Ne = new Map;

      function ke() {
        const e = [];
        Ne.forEach(((t, n) => {
          const r = n.getBoundingClientRect();
          var o, a;
          a = r, ((o = t.rect).width !== a.width || o.height !== a.height || o.top !== a.top || o.right !== a.right || o.bottom !== a.bottom || o.left !== a.left) && (t.rect = r, e.push(t))
        })), e.forEach((e => {
          e.callbacks.forEach((t => t(e.rect)))
        })), Le = requestAnimationFrame(ke)
      }

      function De(e) {
        const [t, n] = u.useState();
        return u.useEffect((() => {
          if (e) {
            const t = function (e, t) {
              const n = Ne.get(e);
              return void 0 === n ? (Ne.set(e, {
                rect: {},
                callbacks: [t]
              }), 1 === Ne.size && (Le = requestAnimationFrame(ke))) : (n.callbacks.push(t), t(e.getBoundingClientRect())), () => {
                const n = Ne.get(e);
                if (void 0 === n) return;
                const r = n.callbacks.indexOf(t);
                r > -1 && n.callbacks.splice(r, 1), 0 === n.callbacks.length && (Ne.delete(e), 0 === Ne.size && cancelAnimationFrame(Le))
              }
            }(e, n);
            return () => {
              n(void 0), t()
            }
          }
        }), [e]), t
      }

      function Fe(e, t = []) {
        let n = [];
        const r = () => {
          const t = n.map((e => u.createContext(e)));
          return function (n) {
            const r = (null == n ? void 0 : n[e]) || t;
            return u.useMemo((() => ({
              [`__scope${e}`]: {
                ...n,
                [e]: r
              }
            })), [n, r])
          }
        };
        return r.scopeName = e, [function (t, r) {
          const o = u.createContext(r),
            a = n.length;

          function c(t) {
            const {
              scope: n,
              children: r,
              ...c
            } = t, i = (null == n ? void 0 : n[e][a]) || o, l = u.useMemo((() => c), Object.values(c));
            return u.createElement(i.Provider, {
              value: l
            }, r)
          }
          return n = [...n, r], c.displayName = t + "Provider", [c, function (n, c) {
            const i = (null == c ? void 0 : c[e][a]) || o,
              l = u.useContext(i);
            if (l) return l;
            if (void 0 !== r) return r;
            throw new Error(`\`${n}\` must be used within \`${t}\``)
          }]
        }, Me(r, ...t)]
      }

      function Me(...e) {
        const t = e[0];
        if (1 === e.length) return t;
        const n = () => {
          const n = e.map((e => ({
            useScope: e(),
            scopeName: e.scopeName
          })));
          return function (e) {
            const r = n.reduce(((t, {
              useScope: n,
              scopeName: r
            }) => ({
              ...t,
              ...n(e)[`__scope${r}`]
            })), {});
            return u.useMemo((() => ({
              [`__scope${t.scopeName}`]: r
            })), [r])
          }
        };
        return n.scopeName = t.scopeName, n
      }

      function ze(e, t, n) {
        const r = e["x" === n ? "left" : "top"],
          o = "x" === n ? "width" : "height",
          a = e[o],
          c = t[o];
        return {
          before: r - c,
          start: r,
          center: r + (a - c) / 2,
          end: r + a - c,
          after: r + a
        }
      }

      function Ie(e) {
        return {
          position: "absolute",
          top: 0,
          left: 0,
          minWidth: "max-content",
          willChange: "transform",
          transform: `translate3d(${Math.round(e.x + window.scrollX)}px, ${Math.round(e.y + window.scrollY)}px, 0)`
        }
      }

      function We(e, t, n, r, o) {
        const a = "top" === t || "bottom" === t,
          c = o ? o.width : 0,
          i = o ? o.height : 0,
          l = c / 2 + r;
        let s = "",
          u = "";
        return a ? (s = {
          start: `${l}px`,
          center: "center",
          end: e.width - l + "px"
        }[n], u = "top" === t ? `${e.height + i}px` : -i + "px") : (s = "left" === t ? `${e.width + i}px` : -i + "px", u = {
          start: `${l}px`,
          center: "center",
          end: e.height - l + "px"
        }[n]), `${s} ${u}`
      }
      const $e = {
        position: "fixed",
        top: 0,
        left: 0,
        opacity: 0,
        transform: "translate3d(0, -200%, 0)"
      },
        Ue = {
          position: "absolute",
          opacity: 0
        };

      function Be({
        popperSize: e,
        arrowSize: t,
        arrowOffset: n,
        side: r,
        align: o
      }) {
        const a = (e.width - t.width) / 2,
          c = (e.height - t.width) / 2,
          i = {
            top: 0,
            right: 90,
            bottom: 180,
            left: -90
          }[r],
          l = Math.max(t.width, t.height),
          s = {
            width: `${l}px`,
            height: `${l}px`,
            transform: `rotate(${i}deg)`,
            willChange: "transform",
            position: "absolute",
            [r]: "100%",
            direction: je(r, o)
          };
        return "top" !== r && "bottom" !== r || ("start" === o && (s.left = `${n}px`), "center" === o && (s.left = `${a}px`), "end" === o && (s.right = `${n}px`)), "left" !== r && "right" !== r || ("start" === o && (s.top = `${n}px`), "center" === o && (s.top = `${c}px`), "end" === o && (s.bottom = `${n}px`)), s
      }

      function je(e, t) {
        return ("top" !== e && "right" !== e || "end" !== t) && ("bottom" !== e && "left" !== e || "end" === t) ? "ltr" : "rtl"
      }

      function He(e) {
        return {
          top: "bottom",
          right: "left",
          bottom: "top",
          left: "right"
        }[e]
      }

      function Ye(e, t) {
        return {
          top: e.top < t.top,
          right: e.right > t.right,
          bottom: e.bottom > t.bottom,
          left: e.left < t.left
        }
      }
      const [Xe, qe] = Fe("Popper"), [Ke, Ve] = Xe("Popper"), Ze = u.forwardRef(((e, t) => {
        const {
          __scopePopper: n,
          virtualRef: r,
          ...o
        } = e, a = Ve("PopperAnchor", n), c = u.useRef(null), i = J(t, c);
        return u.useEffect((() => {
          a.onAnchorChange((null == r ? void 0 : r.current) || c.current)
        })), r ? null : u.createElement(oe.div, Q({}, o, {
          ref: i
        }))
      })), [Je, Qe] = Xe("PopperContent"), Ge = u.forwardRef(((e, t) => {
        const {
          __scopePopper: n,
          side: r = "bottom",
          sideOffset: o,
          align: a = "center",
          alignOffset: c,
          collisionTolerance: i,
          avoidCollisions: l = !0,
          ...s
        } = e, d = Ve("PopperContent", n), [f, p] = u.useState(), m = De(d.anchor), [h, v] = u.useState(null), g = Ae(h), [E, w] = u.useState(null), b = Ae(E), y = J(t, (e => v(e))), S = function () {
          const [e, t] = u.useState(void 0);
          return u.useEffect((() => {
            let e;

            function n() {
              t({
                width: window.innerWidth,
                height: window.innerHeight
              })
            }

            function r() {
              window.clearTimeout(e), e = window.setTimeout(n, 100)
            }
            return n(), window.addEventListener("resize", r), () => window.removeEventListener("resize", r)
          }), []), e
        }(), C = S ? DOMRect.fromRect({
          ...S,
          x: 0,
          y: 0
        }) : void 0, {
          popperStyles: P,
          arrowStyles: R,
          placedSide: x,
          placedAlign: T
        } = function ({
          anchorRect: e,
          popperSize: t,
          arrowSize: n,
          arrowOffset: r = 0,
          side: o,
          sideOffset: a = 0,
          align: c,
          alignOffset: i = 0,
          shouldAvoidCollisions: l = !0,
          collisionBoundariesRect: s,
          collisionTolerance: u = 0
        }) {
          if (!e || !t || !s) return {
            popperStyles: $e,
            arrowStyles: Ue
          };
          const d = function (e, t, n = 0, r = 0, o) {
            const a = o ? o.height : 0,
              c = ze(t, e, "x"),
              i = ze(t, e, "y"),
              l = i.before - n - a,
              s = i.after + n + a,
              u = c.before - n - a,
              d = c.after + n + a;
            return {
              top: {
                start: {
                  x: c.start + r,
                  y: l
                },
                center: {
                  x: c.center,
                  y: l
                },
                end: {
                  x: c.end - r,
                  y: l
                }
              },
              right: {
                start: {
                  x: d,
                  y: i.start + r
                },
                center: {
                  x: d,
                  y: i.center
                },
                end: {
                  x: d,
                  y: i.end - r
                }
              },
              bottom: {
                start: {
                  x: c.start + r,
                  y: s
                },
                center: {
                  x: c.center,
                  y: s
                },
                end: {
                  x: c.end - r,
                  y: s
                }
              },
              left: {
                start: {
                  x: u,
                  y: i.start + r
                },
                center: {
                  x: u,
                  y: i.center
                },
                end: {
                  x: u,
                  y: i.end - r
                }
              }
            }
          }(t, e, a, i, n),
            f = d[o][c];
          if (!1 === l) {
            const e = Ie(f);
            let a = Ue;
            return n && (a = Be({
              popperSize: t,
              arrowSize: n,
              arrowOffset: r,
              side: o,
              align: c
            })), {
              popperStyles: {
                ...e,
                "--radix-popper-transform-origin": We(t, o, c, r, n)
              },
              arrowStyles: a,
              placedSide: o,
              placedAlign: c
            }
          }
          const p = DOMRect.fromRect({
            ...t,
            ...f
          }),
            m = (h = s, v = u, DOMRect.fromRect({
              width: h.width - 2 * v,
              height: h.height - 2 * v,
              x: h.left + v,
              y: h.top + v
            }));
          var h, v;
          const g = Ye(p, m),
            E = d[He(o)][c],
            w = function (e, t, n) {
              const r = He(e);
              return t[e] && !n[r] ? r : e
            }(o, g, Ye(DOMRect.fromRect({
              ...t,
              ...E
            }), m)),
            b = function (e, t, n, r, o) {
              const a = "top" === n || "bottom" === n,
                c = a ? "left" : "top",
                i = a ? "right" : "bottom",
                l = a ? "width" : "height",
                s = t[l] > e[l];
              return "start" !== r && "center" !== r || !(o[c] && s || o[i] && !s) ? "end" !== r && "center" !== r || !(o[i] && s || o[c] && !s) ? r : "start" : "end"
            }(t, e, o, c, g),
            y = Ie(d[w][b]);
          let S = Ue;
          return n && (S = Be({
            popperSize: t,
            arrowSize: n,
            arrowOffset: r,
            side: w,
            align: b
          })), {
            popperStyles: {
              ...y,
              "--radix-popper-transform-origin": We(t, w, b, r, n)
            },
            arrowStyles: S,
            placedSide: w,
            placedAlign: b
          }
        }({
          anchorRect: m,
          popperSize: g,
          arrowSize: b,
          arrowOffset: f,
          side: r,
          sideOffset: o,
          align: a,
          alignOffset: c,
          shouldAvoidCollisions: l,
          collisionBoundariesRect: C,
          collisionTolerance: i
        }), O = void 0 !== x;
        return u.createElement("div", {
          style: P,
          "data-radix-popper-content-wrapper": ""
        }, u.createElement(Je, {
          scope: n,
          arrowStyles: R,
          onArrowChange: w,
          onArrowOffsetChange: p
        }, u.createElement(oe.div, Q({
          "data-side": x,
          "data-align": T
        }, s, {
          style: {
            ...s.style,
            animation: O ? void 0 : "none"
          },
          ref: y
        }))))
      })), et = u.forwardRef((function (e, t) {
        const {
          __scopePopper: n,
          offset: r,
          ...o
        } = e, a = Qe("PopperArrow", n), {
          onArrowOffsetChange: c
        } = a;
        return u.useEffect((() => c(r)), [c, r]), u.createElement("span", {
          style: {
            ...a.arrowStyles,
            pointerEvents: "none"
          }
        }, u.createElement("span", {
          ref: a.onArrowChange,
          style: {
            display: "inline-block",
            verticalAlign: "top",
            pointerEvents: "auto"
          }
        }, u.createElement(_e, Q({}, o, {
          ref: t,
          style: {
            ...o.style,
            display: "block"
          }
        }))))
      })), tt = e => {
        const {
          __scopePopper: t,
          children: n
        } = e, [r, o] = u.useState(null);
        return u.createElement(Ke, {
          scope: t,
          anchor: r,
          onAnchorChange: o
        }, n)
      }, nt = Ze, rt = Ge, ot = et;
      const [at, ct] = Fe("Popover", [qe]), it = qe(), [lt, st] = at("Popover"), ut = u.forwardRef(((e, t) => {
        const {
          __scopePopover: n,
          ...r
        } = e, o = st("PopoverAnchor", n), a = it(n), {
          onCustomAnchorAdd: c,
          onCustomAnchorRemove: i
        } = o;
        return u.useEffect((() => (c(), () => i())), [c, i]), u.createElement(nt, Q({}, a, r, {
          ref: t
        }))
      })), dt = u.forwardRef(((e, t) => {
        const {
          __scopePopover: n,
          ...r
        } = e, o = st("PopoverTrigger", n), a = it(n), c = J(t, o.triggerRef), i = u.createElement(oe.button, Q({
          type: "button",
          "aria-haspopup": "dialog",
          "aria-expanded": o.open,
          "aria-controls": o.contentId,
          "data-state": Et(o.open)
        }, r, {
          ref: c,
          onClick: Ce(e.onClick, o.onOpenToggle)
        }));
        return o.hasCustomAnchor ? i : u.createElement(nt, Q({
          asChild: !0
        }, a), i)
      })), ft = u.forwardRef(((e, t) => {
        const {
          forceMount: n,
          ...r
        } = e, o = st("PopoverContent", e.__scopePopover);
        return u.createElement(ae, {
          present: n || o.open
        }, o.modal ? u.createElement(pt, Q({}, r, {
          ref: t
        })) : u.createElement(mt, Q({}, r, {
          ref: t
        })))
      })), pt = u.forwardRef(((e, t) => {
        const {
          allowPinchZoom: n,
          portalled: r = !0,
          ...o
        } = e, a = st("PopoverContent", e.__scopePopover), c = u.useRef(null), l = J(t, c), s = u.useRef(!1);
        u.useEffect((() => {
          const e = c.current;
          if (e) return i(e)
        }), []);
        const d = r ? de : u.Fragment;
        return u.createElement(d, null, u.createElement(Y, {
          allowPinchZoom: n
        }, u.createElement(ht, Q({}, o, {
          ref: l,
          trapFocus: a.open,
          disableOutsidePointerEvents: !0,
          onCloseAutoFocus: Ce(e.onCloseAutoFocus, (e => {
            var t;
            e.preventDefault(), s.current || null === (t = a.triggerRef.current) || void 0 === t || t.focus()
          })),
          onPointerDownOutside: Ce(e.onPointerDownOutside, (e => {
            const t = e.detail.originalEvent,
              n = 0 === t.button && !0 === t.ctrlKey,
              r = 2 === t.button || n;
            s.current = r
          }), {
            checkForDefaultPrevented: !1
          }),
          onFocusOutside: Ce(e.onFocusOutside, (e => e.preventDefault()), {
            checkForDefaultPrevented: !1
          })
        }))))
      })), mt = u.forwardRef(((e, t) => {
        const {
          portalled: n = !0,
          ...r
        } = e, o = st("PopoverContent", e.__scopePopover), a = u.useRef(!1), c = n ? de : u.Fragment;
        return u.createElement(c, null, u.createElement(ht, Q({}, r, {
          ref: t,
          trapFocus: !1,
          disableOutsidePointerEvents: !1,
          onCloseAutoFocus: t => {
            var n, r;
            null === (n = e.onCloseAutoFocus) || void 0 === n || n.call(e, t), t.defaultPrevented || (a.current || null === (r = o.triggerRef.current) || void 0 === r || r.focus(), t.preventDefault()), a.current = !1
          },
          onInteractOutside: t => {
            var n, r;
            null === (n = e.onInteractOutside) || void 0 === n || n.call(e, t), t.defaultPrevented || (a.current = !0);
            const c = t.target;
            (null === (r = o.triggerRef.current) || void 0 === r ? void 0 : r.contains(c)) && t.preventDefault()
          }
        })))
      })), ht = u.forwardRef(((e, t) => {
        const {
          __scopePopover: n,
          trapFocus: r,
          onOpenAutoFocus: o,
          onCloseAutoFocus: a,
          disableOutsidePointerEvents: c,
          onEscapeKeyDown: i,
          onPointerDownOutside: l,
          onFocusOutside: s,
          onInteractOutside: d,
          ...f
        } = e, p = st("PopoverContent", n), m = it(n);
        return le(), u.createElement(me, {
          asChild: !0,
          loop: !0,
          trapped: r,
          onMountAutoFocus: o,
          onUnmountAutoFocus: a
        }, u.createElement(Re, {
          asChild: !0,
          disableOutsidePointerEvents: c,
          onInteractOutside: d,
          onEscapeKeyDown: i,
          onPointerDownOutside: l,
          onFocusOutside: s,
          onDismiss: () => p.onOpenChange(!1)
        }, u.createElement(rt, Q({
          "data-state": Et(p.open),
          role: "dialog",
          id: p.contentId
        }, m, f, {
          ref: t,
          style: {
            ...f.style,
            "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)"
          }
        }))))
      })), vt = u.forwardRef(((e, t) => {
        const {
          __scopePopover: n,
          ...r
        } = e, o = st("PopoverClose", n);
        return u.createElement(oe.button, Q({
          type: "button"
        }, r, {
          ref: t,
          onClick: Ce(e.onClick, (() => o.onOpenChange(!1)))
        }))
      })), gt = u.forwardRef(((e, t) => {
        const {
          __scopePopover: n,
          ...r
        } = e, o = it(n);
        return u.createElement(ot, Q({}, o, r, {
          ref: t
        }))
      }));

      function Et(e) {
        return e ? "open" : "closed"
      }
      const wt = e => {
        const {
          __scopePopover: t,
          children: n,
          open: r,
          defaultOpen: o,
          onOpenChange: a,
          modal: c = !1
        } = e, i = it(t), l = u.useRef(null), [s, d] = u.useState(!1), [f = !1, p] = function ({
          prop: e,
          defaultProp: t,
          onChange: n = (() => { })
        }) {
          const [r, o] = function ({
            defaultProp: e,
            onChange: t
          }) {
            const n = u.useState(e),
              [r] = n,
              o = u.useRef(r),
              a = fe(t);
            return u.useEffect((() => {
              o.current !== r && (a(r), o.current = r)
            }), [r, o, a]), n
          }({
            defaultProp: t,
            onChange: n
          }), a = void 0 !== e, c = a ? e : r, i = fe(n);
          return [c, u.useCallback((t => {
            if (a) {
              const n = t,
                r = "function" == typeof t ? n(e) : t;
              r !== e && i(r)
            } else o(t)
          }), [a, e, o, i])]
        }({
          prop: r,
          defaultProp: o,
          onChange: a
        });
        return u.createElement(tt, i, u.createElement(lt, {
          scope: t,
          contentId: V(),
          triggerRef: l,
          open: f,
          onOpenChange: p,
          onOpenToggle: u.useCallback((() => p((e => !e))), [p]),
          hasCustomAnchor: s,
          onCustomAnchorAdd: u.useCallback((() => d(!0)), []),
          onCustomAnchorRemove: u.useCallback((() => d(!1)), []),
          modal: c
        }, n))
      },
        bt = ut,
        yt = dt,
        St = ft,
        Ct = vt,
        Pt = gt;
      const [Rt, xt] = Fe("ScrollArea"), [Tt, Ot] = Rt("ScrollArea"), _t = u.forwardRef(((e, t) => {
        const {
          __scopeScrollArea: n,
          type: r = "hover",
          scrollHideDelay: o = 600,
          ...a
        } = e, [c, i] = u.useState(null), [l, s] = u.useState(null), [d, f] = u.useState(null), [p, m] = u.useState(null), [h, v] = u.useState(null), [g, E] = u.useState(0), [w, b] = u.useState(0), [y, S] = u.useState(!1), [C, P] = u.useState(!1), R = J(t, (e => i(e))), x = function (e, t) {
          const [n, r] = u.useState("ltr"), [o, a] = u.useState(), c = u.useRef(0);
          return u.useEffect((() => {
            if (void 0 === t && null != e && e.parentElement) {
              const t = getComputedStyle(e.parentElement);
              a(t)
            }
          }), [e, t]), u.useEffect((() => (void 0 === t && function e() {
            c.current = requestAnimationFrame((() => {
              const t = null == o ? void 0 : o.direction;
              t && r(t), e()
            }))
          }(), () => cancelAnimationFrame(c.current))), [o, t, r]), t || n
        }(c, a.dir);
        return u.createElement(Tt, {
          scope: n,
          type: r,
          dir: x,
          scrollHideDelay: o,
          scrollArea: c,
          viewport: l,
          onViewportChange: s,
          content: d,
          onContentChange: f,
          scrollbarX: p,
          onScrollbarXChange: m,
          scrollbarXEnabled: y,
          onScrollbarXEnabledChange: S,
          scrollbarY: h,
          onScrollbarYChange: v,
          scrollbarYEnabled: C,
          onScrollbarYEnabledChange: P,
          onCornerWidthChange: E,
          onCornerHeightChange: b
        }, u.createElement(oe.div, Q({}, a, {
          ref: R,
          style: {
            position: "relative",
            "--radix-scroll-area-corner-width": g + "px",
            "--radix-scroll-area-corner-height": w + "px",
            ...e.style
          }
        })))
      })), At = u.forwardRef(((e, t) => {
        const {
          __scopeScrollArea: n,
          children: r,
          ...o
        } = e, a = Ot("ScrollAreaViewport", n), c = J(t, u.useRef(null), a.onViewportChange);
        return u.createElement(u.Fragment, null, u.createElement("style", {
          dangerouslySetInnerHTML: {
            __html: "[data-radix-scroll-area-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-scroll-area-viewport]::-webkit-scrollbar{display:none}"
          }
        }), u.createElement(oe.div, Q({
          "data-radix-scroll-area-viewport": ""
        }, o, {
          ref: c,
          style: {
            overflowX: a.scrollbarXEnabled ? "scroll" : "hidden",
            overflowY: a.scrollbarYEnabled ? "scroll" : "hidden",
            ...e.style
          }
        }), u.createElement("div", {
          ref: a.onContentChange,
          style: {
            minWidth: "100%",
            display: "table"
          }
        }, r)))
      })), Lt = u.forwardRef(((e, t) => {
        const {
          forceMount: n,
          ...r
        } = e, o = Ot("ScrollAreaScrollbar", e.__scopeScrollArea), {
          onScrollbarXEnabledChange: a,
          onScrollbarYEnabledChange: c
        } = o, i = "horizontal" === e.orientation;
        return u.useEffect((() => (i ? a(!0) : c(!0), () => {
          i ? a(!1) : c(!1)
        })), [i, a, c]), "hover" === o.type ? u.createElement(Nt, Q({}, r, {
          ref: t,
          forceMount: n
        })) : "scroll" === o.type ? u.createElement(kt, Q({}, r, {
          ref: t,
          forceMount: n
        })) : "auto" === o.type ? u.createElement(Dt, Q({}, r, {
          ref: t,
          forceMount: n
        })) : "always" === o.type ? u.createElement(Ft, Q({}, r, {
          ref: t
        })) : null
      })), Nt = u.forwardRef(((e, t) => {
        const {
          forceMount: n,
          ...r
        } = e, o = Ot("ScrollAreaScrollbar", e.__scopeScrollArea), [a, c] = u.useState(!1);
        return u.useEffect((() => {
          const e = o.scrollArea;
          let t = 0;
          if (e) {
            const n = () => {
              window.clearTimeout(t), c(!0)
            },
              r = () => {
                t = window.setTimeout((() => c(!1)), o.scrollHideDelay)
              };
            return e.addEventListener("pointerenter", n), e.addEventListener("pointerleave", r), () => {
              e.removeEventListener("pointerenter", n), e.removeEventListener("pointerleave", r)
            }
          }
        }), [o.scrollArea, o.scrollHideDelay]), u.createElement(ae, {
          present: n || a
        }, u.createElement(Dt, Q({
          "data-state": a ? "visible" : "hidden"
        }, r, {
          ref: t
        })))
      })), kt = u.forwardRef(((e, t) => {
        const {
          forceMount: n,
          ...r
        } = e, o = Ot("ScrollAreaScrollbar", e.__scopeScrollArea), a = "horizontal" === e.orientation, c = Vt((() => l("SCROLL_END")), 100), [i, l] = ("hidden", s = {
          hidden: {
            SCROLL: "scrolling"
          },
          scrolling: {
            SCROLL_END: "idle",
            POINTER_ENTER: "interacting"
          },
          interacting: {
            SCROLL: "interacting",
            POINTER_LEAVE: "idle"
          },
          idle: {
            HIDE: "hidden",
            SCROLL: "scrolling",
            POINTER_ENTER: "interacting"
          }
        }, u.useReducer(((e, t) => {
          const n = s[e][t];
          return null != n ? n : e
        }), "hidden"));
        var s;
        return u.useEffect((() => {
          if ("idle" === i) {
            const e = window.setTimeout((() => l("HIDE")), o.scrollHideDelay);
            return () => window.clearTimeout(e)
          }
        }), [i, o.scrollHideDelay, l]), u.useEffect((() => {
          const e = o.viewport,
            t = a ? "scrollLeft" : "scrollTop";
          if (e) {
            let n = e[t];
            const r = () => {
              const r = e[t];
              n !== r && (l("SCROLL"), c()), n = r
            };
            return e.addEventListener("scroll", r), () => e.removeEventListener("scroll", r)
          }
        }), [o.viewport, a, l, c]), u.createElement(ae, {
          present: n || "hidden" !== i
        }, u.createElement(Ft, Q({
          "data-state": "hidden" === i ? "hidden" : "visible"
        }, r, {
          ref: t,
          onPointerEnter: Ce(e.onPointerEnter, (() => l("POINTER_ENTER"))),
          onPointerLeave: Ce(e.onPointerLeave, (() => l("POINTER_LEAVE")))
        })))
      })), Dt = u.forwardRef(((e, t) => {
        const n = Ot("ScrollAreaScrollbar", e.__scopeScrollArea),
          {
            forceMount: r,
            ...o
          } = e,
          [a, c] = u.useState(!1),
          i = "horizontal" === e.orientation,
          l = Vt((() => {
            if (n.viewport) {
              const e = n.viewport.offsetWidth < n.viewport.scrollWidth,
                t = n.viewport.offsetHeight < n.viewport.scrollHeight;
              c(i ? e : t)
            }
          }), 10);
        return Zt(n.viewport, l), Zt(n.content, l), u.createElement(ae, {
          present: r || a
        }, u.createElement(Ft, Q({
          "data-state": a ? "visible" : "hidden"
        }, o, {
          ref: t
        })))
      })), Ft = u.forwardRef(((e, t) => {
        const {
          orientation: n = "vertical",
          ...r
        } = e, o = Ot("ScrollAreaScrollbar", e.__scopeScrollArea), a = u.useRef(null), c = u.useRef(0), [i, l] = u.useState({
          content: 0,
          viewport: 0,
          scrollbar: {
            size: 0,
            paddingStart: 0,
            paddingEnd: 0
          }
        }), s = jt(i.viewport, i.content), d = {
          ...r,
          sizes: i,
          onSizesChange: l,
          hasThumb: Boolean(s > 0 && s < 1),
          onThumbChange: e => a.current = e,
          onThumbPointerUp: () => c.current = 0,
          onThumbPointerDown: e => c.current = e
        };

        function f(e, t) {
          return function (e, t, n, r = "ltr") {
            const o = Ht(n),
              a = t || o / 2,
              c = o - a,
              i = n.scrollbar.paddingStart + a,
              l = n.scrollbar.size - n.scrollbar.paddingEnd - c,
              s = n.content - n.viewport;
            return Xt([i, l], "ltr" === r ? [0, s] : [-1 * s, 0])(e)
          }(e, c.current, i, t)
        }
        return "horizontal" === n ? u.createElement(Mt, Q({}, d, {
          ref: t,
          onThumbPositionChange: () => {
            if (o.viewport && a.current) {
              const e = Yt(o.viewport.scrollLeft, i, o.dir);
              a.current.style.transform = `translate3d(${e}px, 0, 0)`
            }
          },
          onWheelScroll: e => {
            o.viewport && (o.viewport.scrollLeft = e)
          },
          onDragScroll: e => {
            o.viewport && (o.viewport.scrollLeft = f(e, o.dir))
          }
        })) : "vertical" === n ? u.createElement(zt, Q({}, d, {
          ref: t,
          onThumbPositionChange: () => {
            if (o.viewport && a.current) {
              const e = Yt(o.viewport.scrollTop, i);
              a.current.style.transform = `translate3d(0, ${e}px, 0)`
            }
          },
          onWheelScroll: e => {
            o.viewport && (o.viewport.scrollTop = e)
          },
          onDragScroll: e => {
            o.viewport && (o.viewport.scrollTop = f(e))
          }
        })) : null
      })), Mt = u.forwardRef(((e, t) => {
        const {
          sizes: n,
          onSizesChange: r,
          ...o
        } = e, a = Ot("ScrollAreaScrollbar", e.__scopeScrollArea), [c, i] = u.useState(), l = u.useRef(null), s = J(t, l, a.onScrollbarXChange);
        return u.useEffect((() => {
          l.current && i(getComputedStyle(l.current))
        }), [l]), u.createElement($t, Q({
          "data-orientation": "horizontal"
        }, o, {
          ref: s,
          sizes: n,
          style: {
            bottom: 0,
            left: "rtl" === a.dir ? "var(--radix-scroll-area-corner-width)" : 0,
            right: "ltr" === a.dir ? "var(--radix-scroll-area-corner-width)" : 0,
            "--radix-scroll-area-thumb-width": Ht(n) + "px",
            ...e.style
          },
          onThumbPointerDown: t => e.onThumbPointerDown(t.x),
          onDragScroll: t => e.onDragScroll(t.x),
          onWheelScroll: (t, n) => {
            if (a.viewport) {
              const r = a.viewport.scrollLeft + t.deltaX;
              e.onWheelScroll(r), qt(r, n) && t.preventDefault()
            }
          },
          onResize: () => {
            l.current && a.viewport && c && r({
              content: a.viewport.scrollWidth,
              viewport: a.viewport.offsetWidth,
              scrollbar: {
                size: l.current.clientWidth,
                paddingStart: Bt(c.paddingLeft),
                paddingEnd: Bt(c.paddingRight)
              }
            })
          }
        }))
      })), zt = u.forwardRef(((e, t) => {
        const {
          sizes: n,
          onSizesChange: r,
          ...o
        } = e, a = Ot("ScrollAreaScrollbar", e.__scopeScrollArea), [c, i] = u.useState(), l = u.useRef(null), s = J(t, l, a.onScrollbarYChange);
        return u.useEffect((() => {
          l.current && i(getComputedStyle(l.current))
        }), [l]), u.createElement($t, Q({
          "data-orientation": "vertical"
        }, o, {
          ref: s,
          sizes: n,
          style: {
            top: 0,
            right: "ltr" === a.dir ? 0 : void 0,
            left: "rtl" === a.dir ? 0 : void 0,
            bottom: "var(--radix-scroll-area-corner-height)",
            "--radix-scroll-area-thumb-height": Ht(n) + "px",
            ...e.style
          },
          onThumbPointerDown: t => e.onThumbPointerDown(t.y),
          onDragScroll: t => e.onDragScroll(t.y),
          onWheelScroll: (t, n) => {
            if (a.viewport) {
              const r = a.viewport.scrollTop + t.deltaY;
              e.onWheelScroll(r), qt(r, n) && t.preventDefault()
            }
          },
          onResize: () => {
            l.current && a.viewport && c && r({
              content: a.viewport.scrollHeight,
              viewport: a.viewport.offsetHeight,
              scrollbar: {
                size: l.current.clientHeight,
                paddingStart: Bt(c.paddingTop),
                paddingEnd: Bt(c.paddingBottom)
              }
            })
          }
        }))
      })), [It, Wt] = Rt("ScrollAreaScrollbar"), $t = u.forwardRef(((e, t) => {
        const {
          __scopeScrollArea: n,
          sizes: r,
          hasThumb: o,
          onThumbChange: a,
          onThumbPointerUp: c,
          onThumbPointerDown: i,
          onThumbPositionChange: l,
          onDragScroll: s,
          onWheelScroll: d,
          onResize: f,
          ...p
        } = e, m = Ot("ScrollAreaScrollbar", n), [h, v] = u.useState(null), g = J(t, (e => v(e))), E = u.useRef(null), w = u.useRef(""), b = m.viewport, y = r.content - r.viewport, S = fe(d), C = fe(l), P = Vt(f, 10);

        function R(e) {
          if (E.current) {
            const t = e.clientX - E.current.left,
              n = e.clientY - E.current.top;
            s({
              x: t,
              y: n
            })
          }
        }
        return u.useEffect((() => {
          const e = e => {
            const t = e.target;
            (null == h ? void 0 : h.contains(t)) && S(e, y)
          };
          return document.addEventListener("wheel", e, {
            passive: !1
          }), () => document.removeEventListener("wheel", e, {
            passive: !1
          })
        }), [b, h, y, S]), u.useEffect(C, [r, C]), Zt(h, P), Zt(m.content, P), u.createElement(It, {
          scope: n,
          scrollbar: h,
          hasThumb: o,
          onThumbChange: fe(a),
          onThumbPointerUp: fe(c),
          onThumbPositionChange: C,
          onThumbPointerDown: fe(i)
        }, u.createElement(oe.div, Q({}, p, {
          ref: g,
          style: {
            position: "absolute",
            ...p.style
          },
          onPointerDown: Ce(e.onPointerDown, (e => {
            0 === e.button && (e.target.setPointerCapture(e.pointerId), E.current = h.getBoundingClientRect(), w.current = document.body.style.webkitUserSelect, document.body.style.webkitUserSelect = "none", R(e))
          })),
          onPointerMove: Ce(e.onPointerMove, R),
          onPointerUp: Ce(e.onPointerUp, (e => {
            e.target.releasePointerCapture(e.pointerId), document.body.style.webkitUserSelect = w.current, E.current = null
          }))
        })))
      })), Ut = u.forwardRef(((e, t) => {
        const {
          __scopeScrollArea: n,
          style: r,
          ...o
        } = e, a = Ot("ScrollbarThumb", n), c = Wt("ScrollbarThumb", n), {
          onThumbPositionChange: i
        } = c, l = J(t, (e => c.onThumbChange(e))), s = u.useRef(), d = Vt((() => {
          s.current && (s.current(), s.current = void 0)
        }), 100);
        return u.useEffect((() => {
          const e = a.viewport;
          if (e) {
            const t = () => {
              if (d(), !s.current) {
                const t = Kt(e, i);
                s.current = t, i()
              }
            };
            return i(), e.addEventListener("scroll", t), () => e.removeEventListener("scroll", t)
          }
        }), [a.viewport, d, i]), c.hasThumb ? u.createElement(oe.div, Q({}, o, {
          ref: l,
          style: {
            width: "var(--radix-scroll-area-thumb-width)",
            height: "var(--radix-scroll-area-thumb-height)",
            ...r
          },
          onPointerDownCapture: Ce(e.onPointerDownCapture, (e => {
            const t = e.target.getBoundingClientRect(),
              n = e.clientX - t.left,
              r = e.clientY - t.top;
            c.onThumbPointerDown({
              x: n,
              y: r
            })
          })),
          onPointerUp: Ce(e.onPointerUp, c.onThumbPointerUp)
        })) : null
      }));

      function Bt(e) {
        return e ? parseInt(e, 10) : 0
      }

      function jt(e, t) {
        const n = e / t;
        return isNaN(n) ? 0 : n
      }

      function Ht(e) {
        const t = jt(e.viewport, e.content),
          n = e.scrollbar.paddingStart + e.scrollbar.paddingEnd,
          r = (e.scrollbar.size - n) * t;
        return Math.max(r, 18)
      }

      function Yt(e, t, n = "ltr") {
        const r = Ht(t),
          o = t.scrollbar.paddingStart + t.scrollbar.paddingEnd,
          a = t.scrollbar.size - o,
          c = t.content - t.viewport,
          i = a - r,
          l = function (e, [t, n]) {
            return Math.min(n, Math.max(t, e))
          }(e, "ltr" === n ? [0, c] : [-1 * c, 0]);
        return Xt([0, c], [0, i])(l)
      }

      function Xt(e, t) {
        return n => {
          if (e[0] === e[1] || t[0] === t[1]) return t[0];
          const r = (t[1] - t[0]) / (e[1] - e[0]);
          return t[0] + r * (n - e[0])
        }
      }

      function qt(e, t) {
        return e > 0 && e < t
      }
      const Kt = (e, t = (() => { })) => {
        let n = {
          left: e.scrollLeft,
          top: e.scrollTop
        },
          r = 0;
        return function o() {
          const a = {
            left: e.scrollLeft,
            top: e.scrollTop
          },
            c = n.left !== a.left,
            i = n.top !== a.top;
          (c || i) && t(), n = a, r = window.requestAnimationFrame(o)
        }(), () => window.cancelAnimationFrame(r)
      };

      function Vt(e, t) {
        const n = fe(e),
          r = u.useRef(0);
        return u.useEffect((() => () => window.clearTimeout(r.current)), []), u.useCallback((() => {
          window.clearTimeout(r.current), r.current = window.setTimeout(n, t)
        }), [n, t])
      }

      function Zt(e, t) {
        const n = fe(t);
        X((() => {
          let t = 0;
          if (e) {
            const r = new ResizeObserver((() => {
              cancelAnimationFrame(t), t = window.requestAnimationFrame(n)
            }));
            return r.observe(e), () => {
              window.cancelAnimationFrame(t), r.unobserve(e)
            }
          }
        }), [e, n])
      }
      const Jt = _t,
        Qt = At,
        Gt = Lt,
        en = Ut;
      var tn = n(4831),
        nn = n(5),
        rn = n(1438),
        on = n(4412);
      const an = window.innerWidth < 1280,
        cn = window.boostPFSAppConfig?.settings.labelTranslations[window.Shopify.locale];

      function ln() {
        const [e, t] = (0, u.useState)(!1), [n, r] = (0, u.useState)((() => new URLSearchParams(window.location.search).get("q") ?? "")), {
          status: o,
          results: a
        } = function (e) {
          const {
            data: t,
            resetLaggy: n,
            error: r
          } = (0, nn.Z)(e ? `${mn}&q=${e}` : null, (e => fetch(e).then((e => e.json()))), {
            use: [function (e) {
              return (t, n, r) => {
                const o = (0, u.useRef)(),
                  a = e(t, n, r);
                (0, u.useEffect)((() => {
                  void 0 !== a.data && (o.current = a.data)
                }), [a.data]);
                const c = void 0 === a.data ? o.current : a.data,
                  i = void 0 === a.data && void 0 !== o.current,
                  l = (0, u.useCallback)((() => {
                    o.current = void 0
                  }), []);
                return Object.assign({}, a, {
                  data: c,
                  isLagging: i,
                  resetLaggy: l
                })
              }
            }]
          });
          (0, u.useEffect)((() => {
            e || n()
          }), [e]);
          let o = "idle";
          e && (o = r ? "error" : t ? "success" : "searching");
          return {
            results: t,
            status: o
          }
        }(n);
        (0, u.useEffect)((() => {
          document.body.setAttribute("data-search-overlay", `${e}`)
        }), [e]);
        const c = () => {
          t(!1), r("")
        };
        return u.createElement(wt, {
          modal: !0,
          open: e
        }, u.createElement(bt, {
          className: "c-instant-search__header"
        }, u.createElement(yt, {
          type: "button",
          onClick: () => t(!0),
          className: "c-nav__link c-nav__link--search"
        }, u.createElement("svg", {
          className: "c-ico"
        }, u.createElement("use", {
          xlinkHref: "#icon-search"
        })), u.createElement("span", null, cn?.suggestion.searchBoxPlaceholder.toUpperCase() ?? "SEARCH"))), u.createElement(St, {
          align: "start",
          sideOffset: an ? 0 : 10,
          onEscapeKeyDown: c,
          onPointerDownOutside: c,
          className: "c-instant-search__content font-tertiary text-upper text-milli"
        }, u.createElement("form", {
          className: "c-instant-search__form",
          action: "/search",
          method: "GET"
        }, u.createElement("h2", null, "Search"), u.createElement("input", {
          type: "text",
          name: "q",
          autoComplete: "off",
          autoCorrect: "off",
          autoCapitalize: "off",
          onChange: e => {
            r(e.currentTarget.value.trimStart())
          }
        }), u.createElement("button", {
          type: "submit",
          "aria-label": "Search"
        }, u.createElement("svg", {
          className: "c-ico"
        }, u.createElement("use", {
          xlinkHref: "#icon-search"
        }))), u.createElement(Ct, {
          "aria-label": "Close",
          title: "Close",
          onClick: c
        }, u.createElement("svg", {
          className: "c-ico"
        }, u.createElement("use", {
          xlinkHref: "#icon-close"
        })))), u.createElement(Jt, {
          className: "c-instant-search__results",
          "aria-live": "polite"
        }, u.createElement(Qt, {
          className: "c-instant-search__viewport"
        }, "searching" === o && u.createElement("h2", null, "de" === window.Shopify.locale ? "Suchen..." : "Searching..."), "error" === o && u.createElement("h2", null, "Unexpected error, please try again later"), "success" === o && u.createElement(sn, {
          data: a,
          onQueryChange: e => r(e)
        })), u.createElement(Gt, {
          className: "c-instant-search__bar",
          orientation: "vertical"
        }, u.createElement(en, {
          className: "c-instant-search__thumb"
        }))), u.createElement(Pt, {
          offset: 17,
          className: "c-instant-search__arrow",
          style: {
            opacity: "idle" === o ? 0 : 1
          }
        })))
      }

      function sn({
        data: e,
        onQueryChange: t
      }) {
        const {
          suggestions: n,
          collections: r,
          products: o,
          pages: a,
          query: c,
          all_empty: i,
          did_you_mean: l,
          total_product: s
        } = e;
        return u.createElement(u.Fragment, null, (() => {
          if (i || 0 !== l.length) return u.createElement(u.Fragment, null, u.createElement("h2", null, cn?.error.noSuggestionResult.replace("{{ terms }}", c) ?? u.createElement(u.Fragment, null, 'Sorry, nothing found for "', u.createElement("b", null, c), '"')), l.length > 0 && u.createElement(u.Fragment, null, cn?.suggestion.didYouMean.replace("{{ terms }}", "") ?? "Did you mean:", " ", l.map((e => u.createElement("button", {
            key: e,
            type: "button",
            className: "c-btn c-btn--tertiary",
            onClick: () => t(e)
          }, e)))))
        })(), (() => {
          const e = n.filter((e => e !== c));
          if (0 !== e.length) return u.createElement(u.Fragment, null, u.createElement("h2", null, cn?.suggestion.instantSearchSuggestionsLabel ?? "Suggestions"), u.createElement("ul", null, e.map((e => u.createElement(un, {
            key: e,
            item: e,
            onClick: () => t(e)
          })))))
        })(), (() => {
          if (0 !== o.length) return u.createElement(u.Fragment, null, u.createElement("h2", null, cn?.suggestion.instantSearchProductsLabel ?? "Products"), u.createElement("ul", null, o.map((e => u.createElement(pn, {
            key: e.id,
            item: e
          })))), u.createElement("a", {
            className: "c-instant-search__view-more",
            href: `${window.routes.search_url}?q=${c}`
          }, cn?.suggestion.viewAll.replace("{{ count }}", s) ?? `View all ${s} product(s)`))
        })(), (() => {
          if (0 !== r.length) return u.createElement(u.Fragment, null, u.createElement("h2", null, cn?.suggestion.instantSearchCollectionsLabel ?? "Collections"), u.createElement("ul", null, r.map((e => u.createElement(fn, {
            key: e.id,
            item: e
          })))))
        })(), (() => {
          if (0 !== a.length) return u.createElement(u.Fragment, null, u.createElement("h2", null, cn?.suggestion.instantSearchPagesLabel ?? "Pages"), u.createElement("ul", null, a.map((e => u.createElement(dn, {
            key: e.id,
            item: e
          })))))
        })())
      }

      function un({
        item: e,
        onClick: t
      }) {
        return u.createElement("li", {
          key: e
        }, t ? u.createElement("button", {
          type: "button",
          onClick: t
        }, e) : e)
      }

      function dn({
        item: e
      }) {
        return u.createElement("li", {
          key: e.id,
          className: "c-instant-search__page"
        }, u.createElement("a", {
          href: Shopify.shopUrl + Shopify.routes.root + e.url
        }, e.title))
      }

      function fn({
        item: e
      }) {
        return u.createElement("li", {
          key: e.id,
          className: "c-instant-search__collection"
        }, u.createElement("a", {
          href: `${window.routes.collections_url}/${e.handle}`
        }, e.title))
      }

      function pn({
        item: e
      }) {
        const [t] = e.variants;
        return u.createElement("li", {
          key: e.id,
          className: "c-instant-search__product",
          onClick: () => window.location.replace(`${window.routes.products_url}/${e.handle}`)
        }, u.createElement("img", {
          "data-child": "image",
          className: "o-img o-img--contain",
          src: e.images_info[0]?.src + "&width=110",
          width: "55",
          height: "55",
          alt: ""
        }), u.createElement("div", {
          "data-child": "title"
        }, u.createElement("a", {
          href: `${window.routes.products_url}/${e.handle}`
        }, e.title)), u.createElement("span", {
          "data-child": "price"
        }, rn.lb({
          cents: 100 * Number(t.price)
        })))
      }
      const mn = new URL("https://services.mybcapps.com/bc-sf-filter/search/suggest?shop=demel-wien.myshopify.com&suggestion_limit=2&collection_limit=3&page_limit=3&product_limit=4&dym_limit=2&event_type=suggest&lang=tl1");
      const hn = (0, on.U2)("#app-instant-search");
      (0, tn.s)(hn).render(u.createElement(ln, null)), hn.firstElementChild?.remove()
    },
    8692: (e, t, n) => {
      n.d(t, {
        N: () => o
      });
      class r {
        constructor(e = "") {
          this.eventTarget = void 0, this.eventTarget = document.appendChild(document.createComment(e))
        }
        on(e, t) {
          this.eventTarget.addEventListener(e, t)
        }
        once(e, t) {
          this.eventTarget.addEventListener(e, t, {
            once: !0
          })
        }
        off(e, t) {
          this.eventTarget.removeEventListener(e, t)
        }
        emit(e, t) {
          return this.eventTarget.dispatchEvent(new CustomEvent(e, {
            detail: t
          }))
        }
      }
      const o = new r("Demel - Event Bus")
    },
    1438: (e, t, n) => {
      n.d(t, {
        J8: () => l,
        Xq: () => i,
        hJ: () => c,
        lb: () => a
      });
      var r = n(4412),
        o = n(8692);

      function a({
        cents: e
      }) {
        return new Intl.NumberFormat("de-DE", {
          style: "currency",
          currency: window.Shopify.currency.active
        }).format(e / 100)
      }
      async function c() {
        const e = await fetch("/cart?view=ajax").then((e => e.json()));
        o.N.emit("propify:cart:update", e);
        const t = (0, r.go)(".js-cart-count");
        for (const n of t) n.setAttribute("data-count", `${e.itemCount || ""}`);
        return e
      }
      async function i(e) {
        let t;
        const n = {};
        return e instanceof FormData ? t = e : (t = JSON.stringify(e), n["Content-Type"] = "application/json"), await fetch("/cart/add.js", {
          method: "POST",
          headers: n,
          body: t
        }), c()
      }
      async function l(e) {
        return await fetch("/cart/change.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(e)
        }), c()
      }
    }
  }
]);